import { GetServerSideProps, NextPage } from 'next';

import { SpeakersContent } from '@/components/ui/features/speakers/SpeakersContent/SpeakersContent';
import { SpeakersSearchInput } from '@/components/ui/features/speakers/SpeakersSearchInput/SpeakersSearchInput';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { ThinProfileSort } from '@/enums/ThinProfileSort';
import { querySelectedSpeakersFilterEvent } from '@/queries/algolia-filter-item';
import { queryThinProfileInfinite } from '@/queries/thin-profiles';
import { generateStore } from '@/utils/generateStore';
import { Hydrate, IHydrateProps } from '@/utils/swr/Hydrate';
import { StringParam, urlQueryStringValidate } from '@/utils/url-query-string';

const Speakers: NextPage<IHydrateProps> = ({ fallback }) => {
  return (
    <Hydrate fallback={fallback}>
      <Layout accessFrom={AccessFrom.Core} navigationVariant="default">
        <SpeakersSearchInput />
        <SpeakersContent />
      </Layout>
    </Hydrate>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });
  const { slug, query, event_id, sort } = urlQueryStringValidate<{
    slug: string;
    query: string;
    event_id: string;
    sort: ThinProfileSort;
  }>(context.query, {
    sort: StringParam,
    slug: StringParam,
    query: StringParam,
    event_id: StringParam,
  });

  await store.fetchResourcesInfinite(
    queryThinProfileInfinite(
      {
        query,
        event_id,
        scope: 'with_library_lectures',
      },
      30,
      sort
    )
  );

  if (event_id) {
    await store.fetchResource(
      querySelectedSpeakersFilterEvent({
        event_id,
        query,
        selected_resource: 'event',
        selected_id: event_id,
      })
    );
  }

  return {
    props: {
      fallback: store.fallback,
    },
  };
};

export default Speakers;
